import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const reviews = [
    {
        id: 1,
        text: "The environment of hospital is good and doctors are well trained. Staff is well behaved. My mother was unwell from past many days suffering from lungs issues now after 7 days treatment she is able to eat food she is doing well highly recommended .",
        author: "Aaliya Mukhtar",
        rating: 5,
    },
    {
        id: 2,
        text: "Great experience at this hospital, situated at the city center, very experienced doctors, taking great care of their patients. Very reasonable charges, staff are also very supportive.",
        author: "ratnesh singh",
        rating: 5,
    },
    {
        id: 3,
        text: "  I recently visited Hope Rise hospital and received an outstanding care from your staff. Their compassion, professionalism, and dedication was commendable",
        author: "Alina Ali",
        rating: 5,
    },
    {
        id: 4,
        text: "Dr Minhaj ko Maine apni maaata ji ko dikhaya bhot hi acha response Mila ab mere maaata ji ka sugar maintain rehta hai. Dhanyawaad Dr Sarah.",
        author: "Shah Bano",
        rating: 5,
    },
    {
        id: 5,
        text: "Wonderful experiences",
        author: "sonal rathore",
        rating: 5,
    },
    {
        id: 6,
        text: "I have visited their to consult my mother and Dr Minhaz Ahmad had treated her and now Alhamdulillah she is well and the hospital facility and staff are cool and Awsome.",
        author: "kayeed ahmed",
        rating: 5,
    },
];

const ReviewsSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div className='reviews-section'>
          
            <h1 className='gradient-text'>What Our Customers Say</h1>
            <Slider {...settings}>
                {reviews.map(review => (
                    <div key={review.id} className='review-card'>
                        <p className='review-text'>{review.text}</p>
                        <h4 className='review-author'>- {review.author}</h4>
                        <p className='review-rating'>Rating: {review.rating} ⭐</p>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default ReviewsSlider;
